@if (isVisible) {
  <div class="orientation-selector">
    <button
      type="button"
      class="orientation-selector__trigger"
      [attr.aria-expanded]="isOpen"
      aria-haspopup="true"
      [attr.aria-label]="'Select orientation. Current: ' + currentOption.label"
      [matMenuTriggerFor]="orientationMenu"
      (menuOpened)="onMenuOpened()"
      (menuClosed)="onMenuClosed()"
    >
      <mat-icon
        [svgIcon]="currentOption.icon"
        class="orientation-selector__trigger-icon"
      />
      <span class="orientation-selector__trigger-label">{{
        currentOption.label
      }}</span>
      <mat-icon
        svgIcon="chevron-down"
        class="orientation-selector__trigger-chevron"
      />
    </button>

    <mat-menu
      #orientationMenu="matMenu"
      class="orientation-selector-menu"
      xPosition="before"
    >
      <ng-template matMenuContent>
        <div
          class="orientation-selector__dropdown"
          (click)="$event.stopPropagation()"
        >
          <div class="orientation-selector__header">
            <p class="orientation-selector__title">Select Orientation</p>
            <p class="orientation-selector__subtitle">
              Changing orientation may move your items.
            </p>
          </div>

          <div class="orientation-selector__options">
            @for (option of visibleOptions; track option.type) {
              <button
                type="button"
                class="orientation-selector__option"
                [class.orientation-selector__option--selected]="
                  selectedOrientation === option.type
                "
                [attr.aria-pressed]="selectedOrientation === option.type"
                (click)="selectOrientation(option.type)"
              >
                <mat-icon
                  [svgIcon]="option.icon"
                  class="orientation-selector__option-icon"
                />
                <div class="orientation-selector__option-content">
                  <span class="orientation-selector__option-label">{{
                    option.label
                  }}</span>
                  <span class="orientation-selector__option-desc">{{
                    option.description
                  }}</span>
                </div>
                @if (option.ratio) {
                  <span class="orientation-selector__option-ratio">{{
                    option.ratio
                  }}</span>
                }
              </button>
            }
          </div>

          @if (isCustomOptionVisible() && showCustomFields) {
            <div class="orientation-selector__divider"></div>
            <div class="orientation-selector__custom">
              <div class="orientation-selector__custom-fields">
                <div class="orientation-selector__field">
                  <label
                    class="orientation-selector__field-label"
                    for="orientation-width"
                    >Width</label
                  >
                  <div class="orientation-selector__input-wrapper">
                    <input
                      id="orientation-width"
                      type="number"
                      class="orientation-selector__input"
                      [(ngModel)]="customWidth"
                      min="1"
                      aria-label="Width in pixels"
                    />
                    <span class="orientation-selector__input-suffix">px</span>
                  </div>
                </div>
                <div class="orientation-selector__field">
                  <label
                    class="orientation-selector__field-label"
                    for="orientation-height"
                    >Height</label
                  >
                  <div class="orientation-selector__input-wrapper">
                    <input
                      id="orientation-height"
                      type="number"
                      class="orientation-selector__input"
                      [(ngModel)]="customHeight"
                      min="1"
                      aria-label="Height in pixels"
                    />
                    <span class="orientation-selector__input-suffix">px</span>
                  </div>
                </div>
              </div>
              <div class="orientation-selector__custom-actions">
                <button
                  rv-button
                  variant="secondary"
                  type="button"
                  class="tw-w-full orientation-selector__btn"
                  (click)="cancelCustom()"
                >
                  Cancel
                </button>
                <button
                  rv-button
                  type="button"
                  class="orientation-selector__btn"
                  (click)="applyCustom()"
                >
                  Apply
                </button>
              </div>
            </div>
          }
        </div>
      </ng-template>
    </mat-menu>
  </div>
}
